<template>
  <div>
    <div
      v-if="copy"
      :class="{ 'active': isOpen }"
      class="footnote-button"
      @click="toggleFootnote"
    >
      <span
        class="dark-ben-franklin"
        v-html="noteText"
      />
      <div class="inline-footnote bg-dark-ben-franklin">
        <span v-html="displayIndex" />
      </div>
    </div>
    <div
      v-if="isOpen"
      class="footnote-copy"
      v-html="philaLink(copy)"
    />
  </div>
</template>


<script>
export default {
  name: 'MobileFootnote',
  props: {
    copy: {
      type: String,
      required: true,
    },
    index: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      isOpen: false,
      noteText: "View note",
      displayIndex: null,
    };
  },
  mounted: function() {
    let vm = this;
    vm.displayIndex = vm.index;
  },
  methods: {
    toggleFootnote () {
      let vm = this;
      vm.isOpen = !vm.isOpen;
      vm.noteText = vm.isOpen ? 'Close note' : 'View note';
      vm.noteText = vm.isOpen ? 'Close note' : 'View note';
      vm.displayIndex = vm.isOpen ? 'x' : vm.index;
    },
  },
};
</script>